<template>
    <div class="info__connect connect">
        <span class="icon icon_size_32">
            <span class="icon__symbol"><SvgIcon class="icon" :name="connectionStatus.icon"/></span>
        </span>
    </div>
</template>
<script>
import {mapGetters} from "vuex";
import {useToast} from "vue-toastification";
const connectionStatus = {
    critical: {icon: 'common__server-critical-connection'},
    warning: {icon: 'common__server-no-connection'},
    ok: {icon: 'common__server-connection'},
}

export default {
    name: 'SectionConnection',
    props: {},
    data() {
        return {
            toast: useToast()
        }
    },
    components: {},
    computed: {
        ...mapGetters([
            "getNetworkStatus",
            "getHttpErrors",
        ]),
        no_connection() {
            return this.getNetworkStatus !== 'ok'
        },
        status() {
            return this.getNetworkStatus //'critical','warning','ok'
        },
        connectionStatus() {
            return connectionStatus[this.status]
        },
        network_errors(){
            return this.getHttpErrors.network.count > 1//network error, check your internet connection
        },
        server_errors(){
            return this.getHttpErrors['5xx']['count'] > 10//server errors
        },
        //network_timeouts(){
        //    return this.getHttpErrors.timeout['count'] > 10//server errors
        //}
    },
    watch: {
        status: {
            network_errors:{
                handler: function (nVal) {
                    if(nVal) this.toast.error('Network error, check your internet connection')
                },
                immediate: true
            },
            server_errors:{
                handler: function (nVal) {
                    if(nVal) this.toast.warning('Server Errors')
                },
                immediate: true
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.connect {
    .icon .icon__symbol svg {
        color: var(--connect-icon-color);
    }
}
</style>